import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

export type ErrorPanelProps = {
  backLinkLabel?: string
  backLinkPath?: string
  'data-testid'?: string
  message: string
}

export const ErrorPanel = ({
  backLinkLabel,
  backLinkPath,
  'data-testid': dataTestId = 'components-features-error-panel',
  message,
}: ErrorPanelProps) => {
  const { t } = useTranslation()
  const defaultBackLinkLabel = backLinkLabel ?? t('back_1')

  return (
    <VStack align="center" data-testid={dataTestId} padding={8} spacing={8}>
      <Typography variant="heading1">{message}</Typography>

      {backLinkPath && (
        <Link to={backLinkPath}>
          <Typography variant="link3">{defaultBackLinkLabel}</Typography>
        </Link>
      )}
    </VStack>
  )
}
